import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

let Layout = {
    init: () => {
        Layout.resizeSelect2();
        Layout.disableScrollOnModalOpen();
        if (!Utility.isTouchDevice()) Layout.resizeSelect2();
    },

    resizeSelect2: () => {
        function reinitializeSelect2() {
            $('.select-element').each((index, element) => {
                $(element).select2('destroy');
                Form.initSelect2(element);
            });
        }

        if (!Utility.isTouchDevice()) {
            $(window).on('resize', Utility.debounce(reinitializeSelect2));
        }
    },
    disableScrollOnModalOpen: () => {
        $(document).on('show.bs.modal', (e) => {
            disableBodyScroll(e.target);
        }).on('hide.bs.modal', (e) => {
            enableBodyScroll(e.target);
            clearAllBodyScrollLocks();
            window.player?.pause();
        }).on('hidden.bs.modal', function () {
            if ($('.modal.show').length > 0) $('body').addClass('modal-open');
        });
    }
};

export default Layout;
